/**
 * The permission keys — a MIRROR of backend/src/common/access/permissions.ts.
 * A backend spec fails if the two lists differ.
 *
 * ⚠️ FOR HIDING CONTROLS ONLY. The server enforces every one of these on every
 * request; a button hidden here is a courtesy, never the control.
 */
export type Permission =
  | 'platform.read'
  | 'platform.settings'
  | 'sales.manage'
  | 'customers.manage'
  | 'billing.read'
  | 'billing.manage'
  | 'support.manage'
  | 'team.manage'
  | 'audit.read'
  | 'platform.export'
  | 'pricing.manage'
  | 'customers.lifecycle'
  | 'billing.refund'
  | 'website.manage'
  | 'school.read'
  | 'school.billing'
  | 'school.billing.manage'
  | 'school.staff.manage'
  | 'school.classes.manage'
  | 'school.children.manage'
  | 'school.settings'
  | 'school.support'
  | 'school.export'
  | 'class.play'
  | 'class.attendance'
  | 'class.messages'
  | 'class.reports'
  | 'class.export'

export type OperatorRole = 'OWNER' | 'ADMIN' | 'SALES' | 'SUPPORT' | 'FINANCE' | 'VIEWER'

/** How each operator duty is described on the Team screen (Figma K11). */
export const OPERATOR_ROLE_COPY: Record<OperatorRole, { label: string; blurb: string }> = {
  OWNER: { label: 'Owner', blurb: 'Everything, including team and pricing defaults.' },
  ADMIN: { label: 'Admin', blurb: 'Everything except the team and pricing defaults.' },
  SALES: { label: 'Sales', blurb: 'Requests, set up schools, set price within limits.' },
  SUPPORT: { label: 'Support', blurb: 'View schools, reset logins, view as school.' },
  FINANCE: { label: 'Finance', blurb: 'Invoices, payments, refunds, coupons.' },
  VIEWER: { label: 'Viewer', blurb: 'Can look at everything, change nothing.' },
}
